import React,{useContext, useState, useRef,useEffect, useMemo} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { ensureTrainingInvitationTemplatesLoaded } from '../../../utils/trainingInvitationTemplatesLookup';
import { dispatchTrainingInvitationListUpdated } from '../../../utils/trainingInvitationListSync';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon, InviteDate, InviteTime, InviteLocation, TrainingTheme} from "../../svg/svgIcons";
import AuthContext from '../../../components/AuthContext';
import UtilContext from '../../../components/UtilContext';
import { InputTextarea } from 'primereact/inputtextarea';
import { MultiSelect } from 'primereact/multiselect';
import { InputSwitch } from 'primereact/inputswitch';
import { DateTime } from "luxon";
import { Panel } from 'primereact/panel';
import { Tag } from 'primereact/tag';
import { Message } from 'primereact/message';
import { Divider } from 'primereact/divider';
import { useTrainingCompanies } from '../../../utils/useTrainingCompanies';
import { InfinitySpin } from 'react-loader-spinner';
import {
    computeTrainingSelectionCascade,
    resolveTrainingSelectionDefaults,
    toTrainingSelectionFormValues,
} from '../../../utils/trainingSelectionCascade';
import {
    buildEditFormCompanyContactOptions,
    buildEditFormLecturerOptions,
    buildTrainingCardEditFormValues,
    machineIdsKey,
    mergeTrainingCardCascadeFormValues,
} from '../../../utils/trainingCardEditHydration';
import {
    invitationEmployeeOptions,
    keepInvitationEmployees,
} from '../../../utils/trainingEmployeeScope';
import { uiT as t } from '../../../utils/uiTranslate';

export default function TrainingInvitationAdd({invitation,type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies();
    const {user} = useContext(AuthContext);
    const {toast,openFavoriteDialog,setFastView,getDateFormat} = useContext(UtilContext);
    const dateFmt = getDateFormat?.(state?.module_settings) ?? 'dd.MM.yyyy';
    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);
    const fileListRef = useRef(null);

    const ref = useRef(null);
    const emailContentRef = useRef(null);
    const smsContentRef = useRef(null);
    const [formType,setFormType] = useState(type ? type : "add");

    const [showInvitationPreview,setShowInvitationPreview] = useState(false);
    const [procesedEmailText,setProcesedEmailText] = useState("");
    const [procesedSmsText,setProcesedSmsText] = useState("");

    const [formInvitation,setFormInvitation] = useState(invitation);
    const [trainingDepartment,setTrainingDepartment] = useState([]);
    const [trainings,setTrainings] = useState([]);
    const [trainingTypesList, setTrainingTypesList] = useState([]);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const [trainingCardsList, setTrainingCardsList] = useState([]);
    const [trainingEmployeesList, setTrainingEmployeesList] = useState([]);
    const [loadingData, setLoadingData] = useState(true);

    const [lecturers, setLecturers] = useState([]);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [machines, setMachines] = useState(state.machines || []);
    const [lecturersFallback, setLecturersFallback] = useState([]);
    const effectiveLecturers = (state.lecturers || []).length ? (state.lecturers || []) : lecturersFallback;

    const [emailTemplate,setEmailTemplate] = useState('');
    const [smsTemplate,setSmsTemplate] = useState('');

    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add training-invitation"))?false:true);

    // trng028 (Pozvánka): potrebujeme training_types, company_contacts, training_cards, training_employees.
    // Firmy sú z useTrainingCompanies(), nie z trng012_data. trng012_data vracia všetko naraz (pôvodne pre masku trng012).
    useEffect(() => {
        setLoadingData(true);
        getRequest("/api/trng012_data")
            .then((r) => {
                const d = r?.data ?? r;
                setTrainingTypesList(d?.training_types || []);       // dropdown Školenie, oddelenie, názov v preview, training_company_id, stroje
                setCompanyContactsList(d?.company_contacts || []);  // dropdown Školiteľ, filtre podľa firmy/strojov
                setTrainingCardsList(d?.training_cards || []);      // MultiSelect Zamestnanci (kto má dané školenie v karte)
                setTrainingEmployeesList(d?.training_employees || []); // validácia: či školiteľ má platné školenie
                setTrainings(d?.training_types || []);
            })
            .catch(() => {})
            .finally(() => setLoadingData(false));
    }, []);

    useEffect(() => {
        if ((state.lecturers || []).length > 0) return;
        getRequest("/api/lecturers").then((r) => { const list = r?.data ?? r ?? []; setLecturersFallback(Array.isArray(list) ? list : []); }).catch(() => {});
    }, [state.lecturers?.length]);

    useEffect(() => {
        ensureTrainingInvitationTemplatesLoaded({ dispatch, state });
    }, [dispatch, state.training_invitation_templates_loaded]);

    const dayTimePeriod = [
        {name: 'Hneď',value:'0'},
        {name: t('Common.Notify.Day1Before'),value:'1'},
        {name: t('TrainingInvitationAdd.Text.2_dni_pred'),value:'2'},
        {name: t('TrainingInvitationAdd.Text.3_dni_pred'),value:'3'},
        {name: t('TrainingInvitationAdd.Text.4_dni_pred'),value:'4'},
        {name: t('Common.Notify.Days5Before'),value:'5'},
        {name: t('TrainingInvitationAdd.Text.6_dni_pred'),value:'6'},
        {name: t('Common.Notify.Days7Before'),value:'7'},
        {name: t('TrainingInvitationAdd.Text.15_dni_pred'),value:'15'},
        {name: t('Common.Notify.Days30Before'),value:'30'},
        {name: t('TrainingInvitationAdd.Text.45_dni_pred'),value:'45'},
        {name: t('TrainingInvitationAdd.Text.60_dni_pred'),value:'60'},
    ];


    const cascadeGenRef = useRef(0);
    /** Edit only: false while opening/hydrating so empty async lists cannot wipe stored IDs. */
    const allowEditCascadePruneRef = useRef(false);

    useEffect(() => {
        if (formType === 'edit') allowEditCascadePruneRef.current = false;
    }, [formInvitation, formType]);

    function cascadeSnapshot(overrides) {
        return {
            companies: trainingCompanies,
            machines: state.machines || [],
            lecturerTypes: effectiveLecturers,
            companyContacts: companyContactsList,
            ...overrides,
        };
    }

    function applyTrainingCascade(result, extraValues = {}) {
        const token = ++cascadeGenRef.current;
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
        if (token !== cascadeGenRef.current) return;
        const trainingId = extraValues.training_id ?? formik.values?.training_id;
        const selectedSource = extraValues.employees !== undefined ? extraValues.employees : formik.values.employees;
        // Create mode: always apply cascade pruning. Edit: preserve until user changes a dependency.
        const preserveHydrated = formType === 'edit' && !allowEditCascadePruneRef.current;
        const seed = preserveHydrated && formInvitation
            ? { ...buildTrainingCardEditFormValues(formInvitation), ...formik.values }
            : formik.values;
        const cascaded = mergeTrainingCardCascadeFormValues(
            seed,
            toTrainingSelectionFormValues(result),
            { preserveHydrated },
        );
        formik.setValues({
            ...formik.values,
            ...cascaded,
            ...extraValues,
            employees: keepInvitationEmployees(selectedSource, trainingCardsList, trainingId, {
                companyId: cascaded.company_id ?? result.companyId,
                machineIds: cascaded.machines ?? result.selectedMachineIds,
                lecturerTypeId: cascaded.lecturer_id ?? result.lecturerTypeId,
            }),
        });
    }

    function addNewInvitation(){
        dispatch({type:'create_new_tab',name: t('TrainingInvitationList.Tab.New'), translationKey: 'TrainingInvitationList.Tab.New', legacyLabel: t('TrainingInvitationList.Tab.New'),page:'TrainingInvitationAdd',props:{invitation: null,type:'add'},mask:'trng028'})
    }
    function copyInvitation(){
        dispatch({type:'create_new_tab',name: t('TrainingInvitationList.Tab.New'), translationKey: 'TrainingInvitationList.Tab.New', legacyLabel: t('TrainingInvitationList.Tab.New'),page:'TrainingInvitationAdd',props:{invitation: formik.values,type:'add'},mask:'trng028'})
    }

    const validate = values => {
        const errors = {};
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        if (values?.machines?.length<1) {
            errors.machines = t('Common.RequiredField');
        }
        if (values?.company_contact_id) {
            let company_contact = (companyContactsList || []).find((contact) => contact.id == values?.company_contact_id);
            if(company_contact?.employee_id){
                let card = (trainingEmployeesList || []).filter(card => card.training_id == values?.training_id && card.employee_id == company_contact?.employee_id);
                if(card?.length==0)errors.company_contact_id = t('TrainingInvitationAdd.Text.Skolitel_nema_evidovane_toto_skolenie');
                else if(card?._children?.length == 0 || (card?._children?.length > 0 && new Date(card._children[0].next_training_date) < new Date()))errors.company_contact_id = t('Training.TrainerExpired');
            }
        }
        return errors;
    };

    const formik = useFormik({
        initialValues: formInvitation==null?{
            name: '',invitation_date: '',invitation_time:'',location:'',training_id:'',company_id:'',lecturer_id:'',company_contact_id:'',
            email:true,sms:false,contact_notify:true,email_content:'',sms_content:'',
            notifications:[],employees:[],machines:[],}
            :{
                id:formInvitation.id,name:formInvitation.name,invitation_date:formInvitation.invitation_date,invitation_time:formInvitation.invitation_time,location:formInvitation.location,training_id:formInvitation.training_id,
                company_id:formInvitation.company_id,company_contact_id:formInvitation.company_contact_id,lecturer_id:formInvitation?.company_contact?.lecturer_id || formInvitation?.lecturer_id,
                email:formInvitation.email==1?true:false,sms:formInvitation.sms==1?true:false,contact_notify:formInvitation.contact_notify==1?true:false,
                email_content:formInvitation?.email_content,sms_content:formInvitation?.sms_content,
                notifications:formInvitation?.notifications ? formInvitation?.notifications?.split(',') : [],
                employees:formInvitation.employees.map((employee) => ({name:employee.name,id:employee.id})),
                machines:formInvitation.machines.map((machine) => ({name:machine.name,id:machine.id})),
                delivery_report: formInvitation.delivery_report,
            },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="employees"){
                    formData.append("employees", values.employees.map(employee => employee.id));
                }
                else if(value=="machines"){
                    formData.append("machines", values.machines.map(machine => machine.id));
                }
                else  formData.append(value, values[value] != null ? values[value] : "");
            }
            if(formType=="add"){
                postRequest('/api/training_invitations', formData,true)
                .then((response) => {
                    setFormType("edit");
                    const created = response?.data ?? response;
                    if (created && typeof created === 'object') formik.setValues(created);
                    dispatchTrainingInvitationListUpdated({
                        operation: 'create',
                        id: created?.id ?? null,
                        row: created && typeof created === 'object' ? created : null,
                    });
                    if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                    toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                const recordId = formik.values.id;
                postRequest(`/api/training_invitations/update/${recordId}`, formData,true)
                .then((response) => {
                    const updated = response?.data ?? response;
                    if (updated && typeof updated === 'object') formik.setValues(updated);
                    else formik.setValues(values);
                    const finish = (row) => {
                        dispatchTrainingInvitationListUpdated({
                            operation: 'update',
                            id: row?.id ?? recordId,
                            row: row && typeof row === 'object' ? row : null,
                            // Invitation edits change membership/order fields → page1 invalidation.
                            changedFields: [],
                        });
                        if (closeTab) dispatch({ type: 'close_tab', id: state.selectedTab });
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    };
                    if (recordId == null) {
                        finish(updated && typeof updated === 'object' ? updated : null);
                        return;
                    }
                    getRequest(`/api/training_invitations/${recordId}`).then((r) => {
                        const full = r?.data ?? r;
                        finish(full && typeof full === 'object' ? full : (updated && typeof updated === 'object' ? updated : null));
                    }).catch(() => finish(updated && typeof updated === 'object' ? updated : null));
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('Common.OfflineQueued'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });

    function insertMyText(type,textToInsert){
        if(type=="email"){
            let cursorPosition = emailContentRef.current.selectionStart;
            let textBeforeCursorPosition = emailContentRef.current.value.substring(0, cursorPosition);
            let textAfterCursorPosition = emailContentRef.current.value.substring(cursorPosition, emailContentRef.current.value.length);
            emailContentRef.current.value = textBeforeCursorPosition + textToInsert + textAfterCursorPosition;
            emailContentRef.current.selectionStart = emailContentRef.current.selectionStart + textToInsert.length;
            emailContentRef.current.focus();
            formik.setFieldValue("email_content", emailContentRef.current.value);
        }
        else{
            let cursorPosition = smsContentRef.current.selectionStart;
            let textBeforeCursorPosition = smsContentRef.current.value.substring(0, cursorPosition);
            let textAfterCursorPosition = smsContentRef.current.value.substring(cursorPosition, smsContentRef.current.value.length);
            smsContentRef.current.value = textBeforeCursorPosition + textToInsert + textAfterCursorPosition;
            smsContentRef.current.selectionStart = smsContentRef.current.selectionStart + textToInsert.length;
            smsContentRef.current.focus();
            formik.setFieldValue("sms_content", smsContentRef.current.value);
        }
      }

    function previewInvitation(){
        setShowInvitationPreview(true);
        setProcesedEmailText(formik.values.email_content.replace("[Dátum]",DateTime.fromISO(formik.values.invitation_date).toFormat(dateFmt)).replace("[Čas]",DateTime.fromISO(formik.values.invitation_time).toFormat("HH:MM")).replace("[Miesto]",formik.values.location).replace(t('TrainingInvitationAdd.Text.Nazov_skolenia'),(trainingTypesList || []).find((t) => t.id == formik.values.training_id)?.name ?? ''));
        setProcesedSmsText(formik.values.sms_content.replace("[Dátum]",DateTime.fromISO(formik.values.invitation_date).toFormat(dateFmt)).replace("[Čas]",DateTime.fromISO(formik.values.invitation_time).toFormat("HH:MM")).replace("[Miesto]",formik.values.location).replace(t('TrainingInvitationAdd.Text.Nazov_skolenia'),(trainingTypesList || []).find((t) => t.id == formik.values.training_id)?.name ?? ''));

    }

    function filterTrainings(departmentId){
        setTrainingDepartment(departmentId);
        if(departmentId=="")setTrainings(trainingTypesList);
        else setTrainings(trainingTypesList.filter(training_type => training_type.department?.id === parseInt(departmentId)));
    }

    function changeTraining(training_id){
        if (formType === 'edit') allowEditCascadePruneRef.current = true;
        const training = (trainingTypesList || []).find(t => t.id == training_id);
        const defaults = resolveTrainingSelectionDefaults(training, {
            companyId: formik.values?.company_id,
            machineIds: formik.values?.machines,
        });
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            selectedTraining: training,
            companyId: defaults.companyId,
            machineIds: defaults.machineIds,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })), { training_id });
    }

    function changeCompany(company_id){
        if (formType === 'edit') allowEditCascadePruneRef.current = true;
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: company_id,
            machineIds: formik.values?.machines,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    function changeMachine(nextMachines){
        if (formType === 'edit') {
            const nextKey = machineIdsKey(nextMachines);
            const curKey = machineIdsKey(formik.values?.machines);
            if (nextKey !== '' && nextKey !== curKey) {
                allowEditCascadePruneRef.current = true;
            }
        }
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: formik.values?.company_id,
            machineIds: nextMachines,
            lecturerTypeId: formik.values?.lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    function changeLecturer(lecturer_id){
        if (formType === 'edit') allowEditCascadePruneRef.current = true;
        applyTrainingCascade(computeTrainingSelectionCascade(cascadeSnapshot({
            companyId: formik.values?.company_id,
            machineIds: formik.values?.machines,
            lecturerTypeId: lecturer_id,
            companyContactId: formik.values?.company_contact_id,
        })));
    }

    useEffect(() => {
        if (!companyContactsList.length) return;
        const token = ++cascadeGenRef.current;
        if (formInvitation?.training?.department_id) {
            filterTrainings(formInvitation.training.department_id);
        }
        const trainingId = formik.values?.training_id || formInvitation?.training_id;
        const training = (trainingTypesList || []).find(t => t.id == trainingId) || formInvitation?.training;
        const companyId = formik.values?.company_id || formInvitation?.company_id;
        if (!trainingId && !companyId) return;
        const defaults = resolveTrainingSelectionDefaults(training, {
            companyId,
            machineIds: formik.values?.machines?.length ? formik.values.machines : formInvitation?.machines,
        });
        const result = computeTrainingSelectionCascade(cascadeSnapshot({
            selectedTraining: training,
            companyId: defaults.companyId,
            machineIds: formik.values?.machines?.length ? formik.values.machines : defaults.machineIds,
            lecturerTypeId: formik.values?.lecturer_id || formInvitation?.company_contact?.lecturer_id || formInvitation?.lecturer_id,
            companyContactId: formik.values?.company_contact_id || formInvitation?.company_contact_id,
        }));
        if (token !== cascadeGenRef.current) return;
        setMachines(result.availableMachines);
        setLecturers(result.availableLecturerTypes);
        setCompanyContacts(result.availableContacts);
        // Create: apply cascade as before. Edit: preserve hydrated IDs until user changes deps.
        const preserveHydrated = formType === 'edit' && !allowEditCascadePruneRef.current;
        const seed = formType === 'edit' && formInvitation
            ? { ...buildTrainingCardEditFormValues(formInvitation), ...formik.values }
            : formik.values;
        const cascaded = mergeTrainingCardCascadeFormValues(
            seed,
            toTrainingSelectionFormValues(result),
            { preserveHydrated },
        );
        formik.setValues({
            ...formik.values,
            ...cascaded,
        });
    }, [formInvitation, companyContactsList]);

    const editFormLecturers = useMemo(() => {
        if (formType !== 'edit' || !formInvitation) return lecturers;
        return buildEditFormLecturerOptions({
            cascadeLecturers: lecturers,
            companyContactsList,
            fullLecturers: effectiveLecturers,
            selectedCard: formInvitation,
        });
    }, [formType, formInvitation, lecturers, companyContactsList, effectiveLecturers]);

    const editFormCompanyContacts = useMemo(() => {
        if (formType !== 'edit' || !formInvitation) return companyContacts;
        return buildEditFormCompanyContactOptions({
            cascadeContacts: companyContacts,
            companyContactsList,
            selectedCard: formInvitation,
        });
    }, [formType, formInvitation, companyContacts, companyContactsList]);

    function changeEmailTemplate(template_id){
        setEmailTemplate(template_id);
        if(template_id){
            let my_template = state.training_invitation_templates?.filter((inv_template) => inv_template.id == template_id)[0];
            if(my_template){
                formik.setFieldValue('email_content',my_template?.content);
                emailContentRef.current.value = my_template.content;
                emailContentRef?.current?.focus();
            }
        }
        else{
            formik.setFieldValue('email_content',"");
            emailContentRef.current.value = "";
            emailContentRef?.current?.focus();
        }
    }

    function changeSmsTemplate(template_id){
        setSmsTemplate(template_id);
        if(template_id){
            let my_template = (state.training_invitation_templates || []).find((t) => t.id == template_id);
            if(my_template){
                formik.setFieldValue('sms_content',my_template?.content);
                smsContentRef.current.value = my_template.content;
                smsContentRef?.current?.focus();
            }
        }
        else{
            formik.setFieldValue('sms_content',"");
            smsContentRef.current.value = "";
            smsContentRef?.current?.focus();
        }
    }

    const formatDateTime = (value) => {
        return value ? new Date(value).toLocaleString() : '–';
    };

    return (
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewInvitation()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyInvitation()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('TrainingInvitationList.Tab.New'),"TrainingInvitationAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingInvitationAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        {loadingData ? (
        <div className="flex flex-col items-center justify-center h-[calc(100vh-177px)] bg-gray-100 gap-4">
            <InfinitySpin width="120" color="#333" />
            <span className="text-gray-700">{t('Common.LoadingEllipsis')}</span>
        </div>
        ) : (
        <React.Fragment>
        <div className="relative flex flex-col overflow-y-auto h-[calc(100vh-177px)] bg-gray-100">
            <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
                <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.NOVA_POZVANKA')}</h1>
                <form onSubmit={formik.handleSubmit}>
                <div className="md:grid grid-cols-2 gap-4 mb-2">
                        <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Name')}</label>
                        <input
                            name='name'
                            type="text" required
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="invitation_date"
                            className="block text-md font-semibold text-gray-800"
                        >{t('TrainingInvitationList.Column.Date')}</label>
                        <input
                            name='invitation_date'
                            type="date"
                            onChange={formik.handleChange} value={formik.values.invitation_date}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                        <div>
                        <label
                            htmlFor="invitation_time"
                            className="block text-md font-semibold text-gray-800"
                        >{t('TrainingInvitationList.Column.Time')}</label>
                        <input
                            name='invitation_time'
                            type="time" required
                            onChange={formik.handleChange} value={formik.values.invitation_time}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="location"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Miesto
                        </label>
                        <input
                            name='location'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.location}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                    </div>
                    <div className="md:grid grid-cols-2 gap-4 mb-2">
                            <div>
                        <label
                            htmlFor="trainingDepartment"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.TrainingDepartment')}</label>
                        <select
                        required
                        name='trainingDepartment'
                        onChange={(e) => filterTrainings(e.target.value)} value={trainingDepartment}
                        className="bg-white block w-full  px-4 py-2 mt-2 text-grey-700 border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40">
                        <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                        {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                            ))}
                        </select>
                    </div>
                    <div>
                        <label
                            htmlFor="training_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        {t('Common.TrainingName')}
                        </label>
                        <select required
                        name='training_id'
                        onChange={(e) => changeTraining(e.target.value)} value={formik.values.training_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_skolenie')}</option>
                        {trainings.map((training) => (
                            <option key={training.id} value={training.id}>{training.name}</option>
                        ))}
                        </select>
                    </div>
                    </div>
                    <div>
                        <label
                            htmlFor="company_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.TrainingCompanyShort')}</label>
                        <select required
                        name='company_id'
                        onChange={(e) => changeCompany(e.target.value)} value={formik.values?.company_id}
                        disabled={loadingCompanies}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                        {trainingCompanies.map((training_company) => (
                            <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formik.values?.company_id!="" && formik.values?.company_id!=null) && <><div>
                        <label
                            htmlFor="machines"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Stroj*
                        </label>
                        <MultiSelect value={formik.values.machines} onChange={(e) => changeMachine(e.value)}
                            options={machines.map((machine) =>
                                ({name:machine.name,id:machine.id})
                            )}
                            optionLabel="name"
                            dataKey="id"
                            filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""}
                    </div>
                    {formik.values?.machines?.length > 0 && <><div>
                        <label
                            htmlFor="lecturer_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                        Lektor
                        </label>
                        <select required
                        name='lecturer_id'
                        onChange={(e) => changeLecturer(e.target.value)} value={formik.values?.lecturer_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_lektora')}</option>
                        {(editFormLecturers || lecturers).map((lecturer) => (
                            <option key={lecturer.id} value={lecturer.id}>{lecturer.name}</option>
                        ))}
                        </select>
                    </div>
                    {(formik.values?.lecturer_id!="" && formik.values?.lecturer_id!=null) && <><div>
                        <label
                            htmlFor="company_contact_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.Trainer')}</label>
                        <select required
                        name='company_contact_id'
                        onChange={formik.handleChange} value={formik.values?.company_contact_id}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                        <option value="">{t('Ui.R67.Vyber_skolitela')}</option>
                        {(editFormCompanyContacts || companyContacts).map((contact) => (
                            <option key={contact.id} value={contact.id}>{contact?.employee?.name || contact?.name}</option>
                        ))}
                        </select>
                        {formik.errors.company_contact_id ? <div className="whitespace-pre-line" style={{color:'red'}}>{formik.errors.company_contact_id}</div> : null}
                    </div>
                    {(formik.values?.company_contact_id!="" && formik.values?.company_contact_id!=null) &&<div>
                        <div className="flex justify-content-center mt-2">
                            <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Ui.R67.Poslat_notifikaciu_skolitelovi')}</label>
                            <InputSwitch checked={formik.values.contact_notify} onChange={(e) => formik.setFieldValue("contact_notify",e.value)} />
                        </div>
                        <label
                            for="employees"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Zamestnanci
                        </label>
                        <MultiSelect required value={formik.values.employees} onChange={(e) => formik.setFieldValue("employees",e.value)}
                        options={invitationEmployeeOptions(trainingCardsList, formik.values?.training_id, {
                            companyId: formik.values?.company_id,
                            machineIds: formik.values?.machines,
                            lecturerTypeId: formik.values?.lecturer_id,
                        })}
                        optionLabel="name"
                        filter placeholder={t('Common.SelectEmployees')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        {formik.errors.employees ? <div className="whitespace-pre-line" style={{color:'red'}}>{formik.errors.employees}</div> : null}
                        <div>
                            <label className="block text-md my-2 font-semibold text-gray-800">POČET: {formik.values.employees.length}</label>
                        </div>
                    </div>}</>}</>} </>}
                    <div className="flex justify-content-center mb-2 mt-2">
                        <label className='block text-md font-semibold text-gray-800 mr-2'>Email:</label>
                        <InputSwitch checked={formik.values.email} onChange={(e) => formik.setFieldValue("email",e.value)} />
                    </div>
                    {formik.values.email && <><div>
                        <label
                            htmlFor="email_template_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Vzor_pozvanky_pre_email')}</label>
                        <select
                        name='email_template_id'
                        onChange={(e) => changeEmailTemplate(e.target.value)} value={emailTemplate}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">Bez vzoru</option>
                          {state.training_invitation_templates?.map((template) => (
                            <option key={template.id} value={template.id}>{template.name}</option>
                          ))}
                        </select>
                        </div>
                        <div className='mb-2'>
                        <label
                            htmlFor="email_content"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Obsah_pozvanky_pre_email')}</label>
                        <div className='w-full h-12 flex flex-row justify-start gap-1 px-1 py-1 text-white'>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("email","[Dátum]")}><InviteDate/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("email","[Čas]")}><InviteTime/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("email","[Miesto]")}><InviteLocation/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("email","[Názov školenia]")}><TrainingTheme/></button></div>
                        </div>
                        <InputTextarea ref={emailContentRef} autoResize name='email_content' required onChange={formik.handleChange} value={formik.values.email_content} rows={5} cols={30} className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                    </>}
                    <div className="flex justify-content-center">
                        <label className='block text-md font-semibold text-gray-800 mr-2'>SMS:</label>
                        <InputSwitch checked={formik.values.sms} onChange={(e) => formik.setFieldValue("sms",e.value)} />
                    </div>
                    {formik.values.sms && <><div>
                        <label
                            htmlFor="email_template_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Vzor_pozvanky_pre_SMS')}</label>
                        <select
                        name='sms_template_id'
                        onChange={(e) => changeSmsTemplate(e.target.value)} value={smsTemplate}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">Bez vzoru</option>
                          {state.training_invitation_templates?.map((template) => (
                            <option key={template.id} value={template.id}>{template.name}</option>
                          ))}
                        </select>
                        </div>
                        <div className='mb-2'>
                        <label
                            htmlFor="sms_content"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.Obsah_pozvanky_pre_SMS')}</label>
                        <div className='w-full h-12 flex flex-row justify-start gap-1 px-1 py-1 text-white'>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("sms","[Dátum]")}><InviteDate/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("sms","[Čas]")}><InviteTime/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("sms","[Miesto]")}><InviteLocation/></button></div>
                            <div><button type="button" className='px-2 py-2 rounded-md bg-[#333] hover:bg-gray-600' onClick={() => insertMyText("sms","[Názov školenia]")}><TrainingTheme/></button></div>
                        </div>
                        <InputTextarea ref={smsContentRef} autoResize name='sms_content' required onChange={formik.handleChange} value={formik.values.sms_content} rows={5} cols={30} className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                    </>}
                        <div className='mb-4'>
                            <label className='block text-md font-semibold text-gray-800 mr-2'>Odoslanie upozornenia:</label>
                            <MultiSelect required value={formik.values.notifications} onChange={(e) => formik.setFieldValue("notifications",e.value)} options={dayTimePeriod} optionLabel="name"
                            filter placeholder={t('Common.SelectFrequency')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div>
                            <button type='button' onClick={() => previewInvitation()} className='flex justify-center items-center mt-4 w-full h-10 font-medium mb-2 px-2 py-1 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600 disabled:opacity-25'>{t('Ui.R67.ShowPreview')}</button>
                        </div>

                    <button type='submit' ref={submitRef}></button>
                    </form>
            </div>
            <div>
            {formType=="edit" && <div className="p-4 m-4 bg-white rounded-md shadow-md">
                <Panel header={t('TrainingInvitationAdd.Text.Stav_dorucenia')} className="my-4">
                    <div className="text-sm text-gray-700 mb-4">
                        <strong>Naposledy odoslané:</strong>{' '}
                        <Tag value={formatDateTime(formik.values?.delivery_report?.last_sent)} severity="info" />
                    </div>
                    <Divider />

                    {(() => {
                        const report = formik.values?.delivery_report || {};
                        const formatTS = (ts) => (ts ? formatDateTime(ts) : '');

                        // Zoskup a zhrň položky podľa value (email/phone)
                        const summarize = (items = [], valueKey) => {
                        const map = new Map();
                        items.forEach((it) => {
                            const value = it?.[valueKey];
                            if (!value) return;

                            const sentAt = it?.sent_at || report?.last_sent || null;
                            const prev = map.get(value);

                            const out = prev ?? {
                            value,
                            count: 0,
                            lastSentAt: null,
                            lastError: null,
                            lastContext: null,
                            };

                            out.count += 1;

                            // ak je novší timestamp, prepíš „last*“
                            const isNewer =
                            sentAt &&
                            (!out.lastSentAt || new Date(sentAt).getTime() > new Date(out.lastSentAt).getTime());

                            if (isNewer) {
                            out.lastSentAt = sentAt;
                            out.lastContext = it?.context ?? out.lastContext;
                            out.lastError = it?.error ?? out.lastError;
                            } else {
                            // ak nemáme doteraz error/context, doplň aspoň prvý dostupný
                            if (!out.lastError && it?.error) out.lastError = it.error;
                            if (!out.lastContext && it?.context) out.lastContext = it.context;
                            }

                            map.set(value, out);
                        });

                        return Array.from(map.values()).sort(
                            (a, b) => new Date(b.lastSentAt || 0) - new Date(a.lastSentAt || 0)
                        );
                        };

                        const emailSuccess = summarize(report?.email_success, 'email');
                        const emailFail    = summarize(report?.email_fail, 'email');
                        const smsSuccess   = summarize(report?.sms_success, 'phone');
                        const smsFail      = summarize(report?.sms_fail, 'phone');

                        const Row = ({ tagValue, severity, context, when, error }) => (
                        <div className="mb-1 flex items-center flex-wrap gap-2">
                            <Tag value={tagValue} severity={severity} />
                            {context ? <span className="text-xs text-gray-500">• {context}</span> : null}
                            {when ? <span className="text-xs text-gray-500">• {formatTS(when)}</span> : null}
                            {error ? <span className="text-xs text-red-500">• {error}</span> : null}
                        </div>
                        );

                        return (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                            <div>
                            <h3 className="font-medium mb-2 text-green-700">{t('Ui.R67.Uspesne_e_maily')}</h3>
                            {emailSuccess.length ? (
                                emailSuccess.map((r) => (
                                <Row
                                    key={`ok-mail-${r.value}`}
                                    tagValue={`${r.value}${r.count > 1 ? ` (${r.count}×)` : ''}`}
                                    severity="success"
                                    context={r.lastContext}
                                    when={r.lastSentAt}
                                />
                                ))
                            ) : (
                                <p className="text-gray-500 italic">{t('PreviewMaintenance.CriticalNone')}</p>
                            )}
                            </div>

                            <div>
                            <h3 className="font-medium mb-2 text-red-700">{t('Ui.R67.Neuspesne_e_maily')}</h3>
                            {emailFail.length ? (
                                emailFail.map((r) => (
                                <Row
                                    key={`fail-mail-${r.value}`}
                                    tagValue={`${r.value}${r.count > 1 ? ` (${r.count}×)` : ''}`}
                                    severity="danger"
                                    context={r.lastContext}
                                    when={r.lastSentAt}
                                    error={r.lastError}
                                />
                                ))
                            ) : (
                                <p className="text-gray-500 italic">{t('PreviewMaintenance.CriticalNone')}</p>
                            )}
                            </div>

                            <div>
                            <h3 className="font-medium mb-2 text-green-700">{t('Ui.R67.Uspesne_SMS')}</h3>
                            {smsSuccess.length ? (
                                smsSuccess.map((r) => (
                                <Row
                                    key={`ok-sms-${r.value}`}
                                    tagValue={`${r.value}${r.count > 1 ? ` (${r.count}×)` : ''}`}
                                    severity="success"
                                    context={r.lastContext}
                                    when={r.lastSentAt}
                                />
                                ))
                            ) : (
                                <p className="text-gray-500 italic">{t('PreviewMaintenance.CriticalNone')}</p>
                            )}
                            </div>

                            <div>
                            <h3 className="font-medium mb-2 text-red-700">{t('Ui.R67.Neuspesne_SMS')}</h3>
                            {smsFail.length ? (
                                smsFail.map((r) => (
                                <Row
                                    key={`fail-sms-${r.value}`}
                                    tagValue={`${r.value}${r.count > 1 ? ` (${r.count}×)` : ''}`}
                                    severity="danger"
                                    context={r.lastContext}
                                    when={r.lastSentAt}
                                    error={r.lastError}
                                />
                                ))
                            ) : (
                                <p className="text-gray-500 italic">{t('PreviewMaintenance.CriticalNone')}</p>
                            )}
                            </div>
                        </div>
                        );
                    })()}
                    </Panel>
            </div>}
            {showInvitationPreview && <div className="w-auto p-6 m-4 bg-white rounded-md shadow-md">
                {formik.values?.email && <div className='mb-5'>
                    <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Ui.R67.Nahlad_emailovej_pozvanky')}</label>
                    <InputTextarea autoResize name='content' required value={procesedEmailText} rows={5} cols={30} className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>}
                {formik.values?.sms && <div>
                    <label className='block text-md font-semibold text-gray-800 mr-2'>{t('Ui.R67.Nahlad_sms_pozvanky')}</label>
                    <InputTextarea autoResize name='content' required value={procesedSmsText} rows={5} cols={30} className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                </div>}
            </div>}
            </div>
            </div>
            </div>
        </React.Fragment>
        )}
            </div>
            </>
        );

}